import React, { useState } from "react";
import { Button } from "react-bootstrap";

const ReportTableTarget = ({ selectedData }) => {
  const [currentPage, setCurrentPage] = useState(1);
  const rowsPerPage = 10; // Sesuaikan jumlah data per halaman

  // Ambil data yang akan ditampilkan
  const data = selectedData?.target || [];
  const totalPages = Math.ceil(data.length / rowsPerPage);
  const currentData = data.slice(
    (currentPage - 1) * rowsPerPage,
    currentPage * rowsPerPage
  );

  // Ambil kolom secara dinamis dari data pertama
  const getColumns = () => {
    if (data.length === 0) return [];
    try {
      return Object.keys(JSON.parse(data[0]?.data || "{}"));
    } catch (error) {
      return [];
    }
  };

  const columns = getColumns();

  // Parsing data dengan aman
  const parseData = (json) => {
    try {
      return JSON.parse(json);
    } catch (error) {
      return {};
    }
  };

  return (
    <>
      <div className="table-responsive">
        <table className="table table-bordered table-custome">
          <thead>
            <tr className="text-white">
              <th className="text-center p-2">No</th>
              {columns.map((col, index) => (
                <th key={index} className="text-center p-2">
                  {col}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {currentData.length > 0 ? (
              currentData.map((row, index) => {
                const rowData = parseData(row.data);
                return (
                  <tr key={index}>
                    <td className="p-2">
                      {(currentPage - 1) * rowsPerPage + index + 1}
                    </td>
                    {columns.map((col, idx) => (
                      <td key={idx} className="p-2">
                        {rowData[col] || "-"}
                      </td>
                    ))}
                  </tr>
                );
              })
            ) : (
              <tr>
                <td colSpan={columns.length + 1} className="text-center p-2">
                  No Data
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {/* Pagination */}
      {totalPages > 1 && (
        <div className="d-flex justify-content-between">
          <div>
            Page {currentPage} of {totalPages}
          </div>
          <div>
            <Button
              variant="primary"
              className="btn btn-sm me-2"
              disabled={currentPage === 1}
              onClick={() => setCurrentPage(currentPage - 1)}
            >
              Prev
            </Button>
            <Button
              variant="primary"
              className="btn btn-sm"
              disabled={currentPage === totalPages}
              onClick={() => setCurrentPage(currentPage + 1)}
            >
              Next
            </Button>
          </div>
        </div>
      )}
    </>
  );
};

export default ReportTableTarget;
